<template>
  <!-- <v-layout column wrap > -->
    <v-dialog v-model="dialogshow_historyDetail" max-width="500px" persistent max-height="600px" style="overflow-y: hidden; border-radius: 20px !important;" class="Kanit">

   <v-card class="Kanit">
      <v-card tile>

        <v-toolbar dark class="toolbareditdadmin">

          <v-toolbar-title>ประวัติการใช้งาน</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="closeDialog(false)">
            <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>

      <v-card-text style="height: 75vh !important; overflow-y: scroll; ">
<!-- {{historyItem}} -->
<div style="text-align: right;    margin-top: 20px;">
  <b v-if="historyItem.informer_name">ผู้แจ้ง:</b>  <span style="margin-left: 5px;">{{ historyItem.informer_name}} {{ historyItem.informer_phone? '('+historyItem.informer_phone+')':''}}</span>
  <br v-if="historyItem.informer_name" />
 <!--  <b>แจ้งเมื่อ:</b>   --><span style="font-size: 12px;">{{ momentdatethai(historyItem.created_at)}} เวลา {{ momenttimethai(historyItem.created_at)}}น.</span>

  </div>


<div class="headerRed" style="margin-top: 10px;">
<b>ข้อมูลผู้ป่วย</b>
</div>
<div style="padding: 0px 10px;">
<div style="text-align: left;    margin-top: 10px;">
  <b>ชื่อ-สกุลผู้ป่วย:</b> <br>
  </div>
<div style="text-align: left;text-align: left;
    border-radius: 5px;
    background: #ecececb5;
    padding: 5px;">
  
  <span style="margin-left: 10px;"> {{historyItem.full_name}} </span>
</div>

<v-layout row style="justify-content: center;">
               <v-flex sm6 md6 lg6 xl6 style="padding: 0px 10px;">
<div style="text-align: left;    margin-top: 10px;">
  <b>อายุ:</b> <br>
  </div>
<div style="text-align: left;text-align: left;
    border-radius: 5px;
    background: #ecececb5;
    padding: 5px;">
  
  <span style="margin-left: 10px;"> {{historyItem.age}} </span>
</div>
</v-flex>
<v-flex sm6 md6 lg6 xl6 style="padding: 0px 10px;">
<div style="text-align: left;    margin-top: 10px;">
  <b>เพศ:</b> <br>
  </div>
<div style="text-align: left;text-align: left;
    border-radius: 5px;
    background: #ecececb5;
    padding: 5px;">
  <span style="margin-left: 10px;"> {{historyItem.sex == 'male'? 'ชาย':'หญิง'}} </span>
</div>
</v-flex>
</v-layout>




<div style="text-align: left;    margin-top: 10px;">
  <b>เลขบัตรประจำตัวประชาชน:</b> <br>
  </div>
<div style="text-align: left;text-align: left;
    border-radius: 5px;
    background: #ecececb5;
    padding: 5px;">
  <span style="margin-left: 10px;"> {{historyItem.id_card}} </span>
</div>







<div style="text-align: left;    margin-top: 10px;">
  <b>สถานที่เกิดเหตุ:</b> <br>
  </div>
<div style="text-align: left;text-align: left;
    border-radius: 5px;
    background: #ecececb5;
    padding: 5px;">
  <span style="margin-left: 10px;"> {{historyItem.location? historyItem.location: '-'}} </span>
</div>



</div>



<div v-if="historyItem.send_to_hospital == 'true'" style="margin-top: 20px;">

<div class="headerRed">
<b>ข้อมูลโรงพยาบาล</b>
</div>
<div style="padding: 0px 10px;">
<div style="text-align: left;    margin-top: 10px;">
  <b>ชื่อโรงพยาบาล:</b> <br>
  </div>
<div style="text-align: left;text-align: left;
    border-radius: 5px;
    background: #ecececb5;
    padding: 5px;">
  
  <span style="margin-left: 10px;"> {{historyItem.hospital_name}} </span>
</div>

<div style="text-align: left;    margin-top: 10px;">
  <b>เลขHN:</b> <br>
  </div>
<div style="text-align: left;text-align: left;
    border-radius: 5px;
    background: #ecececb5;
    padding: 5px;">
  
  <span style="margin-left: 10px;"> {{historyItem.hn}} </span>
</div>

<div style="text-align: left;    margin-top: 10px;">
  <b>เบอร์โรงพยาบาล:</b> <br>
  </div>
<div style="text-align: left;text-align: left;
    border-radius: 5px;
    background: #ecececb5;
    padding: 5px;">
  
  <span style="margin-left: 10px;"> {{historyItem.hospital_phone}} </span>
</div>
</div>
</div>

<div v-else-if="historyItem.send_to_hospital == 'false'" style="margin-top: 20px;">

<div class="headerRed">
<b>ข้อมูลญาติ</b>
</div>
<div style="padding: 0px 10px;">
<div style="text-align: left;    margin-top: 10px;">
  <b>เบอร์โทรญาติ:</b> <br>
  </div>
<div style="text-align: left;text-align: left;
    border-radius: 5px;
    background: #ecececb5;
    padding: 5px;">
  
  <span style="margin-left: 10px;"> {{historyItem.relative_phone}} </span>
</div>
</div>
</div>


<div v-if="historyItem.approve_name" style="margin-top: 20px;">

<div class="headerRed">
<b>ข้อมูลผู้ตรวจสอบ</b>
</div>
<div style="padding: 0px 10px;">
<div style="text-align: left;    margin-top: 10px;">
  <b>ชื่อผู้ตรวจสอบ:</b> <br>
  </div>
<div style="text-align: left;text-align: left;
    border-radius: 5px;
    background: #ecececb5;
    padding: 5px;">
  
  <span style="margin-left: 10px;"> {{historyItem.approve_name}} </span>
</div>

<div style="text-align: left;    margin-top: 10px;">
  <b>เบอร์โทรผู้ตรวจสอบ:</b> <br>
  </div>
<div style="text-align: left;text-align: left;
    border-radius: 5px;
    background: #ecececb5;
    padding: 5px;">
  
  <span style="margin-left: 10px;"> {{historyItem.approve_phone? historyItem.approve_phone:'-'}} </span>
</div>
</div>
</div>



<!-- <div style="text-align: left;    margin-top: 10px;">
  <b>แจ้งโดย:</b> <br>
  </div>
<div style="text-align: left;text-align: left;
    border-radius: 5px;
    background: #ecececb5;
    padding: 5px;">
  
  <span style="margin-left: 10px;"> {{historyItem.name_create_by}} </span>
</div> -->
<!-- <div style=" margin-top: 20px;"> -->
<!-- <div style="text-align: right;    margin-top: 30px;">
  <b>แจ้งเมื่อ:</b>  <span style="margin-left: 10px;">{{ momentdatethai(historyItem.create_at)}} เวลา {{ momenttimethai(historyItem.create_at)}}น.</span>
  </div> -->

<!-- </div> -->
<!-- address_name: "เทาเทาเทส"
aed_id: "ccd9ee19-bec2-4c6c-8af3-33b2f9276481"
company_name: "vvv"
deleted_at: null
hn: "etc445"
id_card: "2225856666665"
location: "ghhh"
owner_name: "test"
relative_phone: ""
send_to_hospital: "true"
seq: 1627894571250157800
serial_number: "twt"
status: "approve"
uid: "d2d6c9b5-d4bc-48ff-adf2-bb560bc2aa3c"
updated_at: "2021-08-02T08:56:11.250197Z" -->

          <!-- <div>
          <v-text-field
            label="ชื่อบริษัท"
            single-line
            outlined
            hide-details
            v-model="company_name"
            class="textfieldInput"
            style="margin-bottom: 10px;"
          ></v-text-field>

          <v-textarea
            outlined
            single-line
            no-resize
            hide-details
            label="รายละเอียด"
            value=""
            v-model="company_detail"
            style="margin-bottom: 10px;"
          ></v-textarea>

        </div> -->
       <!--  <v-btn rounded color="#a80f00" style="margin-top: 10px;text-transform: none; color: white;"  @click="closeDialog()" >ยกเลิก</v-btn>
        <v-btn rounded color="#a80f00" style="margin-top: 10px;text-transform: none; color: white;"  @click="editCompany()">แก้ไข</v-btn> -->
        
      </v-card-text>
    </v-card>
  <!-- </v-layout> -->

</v-dialog>
</template>
<script>
import { Decode, Momenttime } from '@/services'
var _ = require('lodash')
var moment = require('moment')
export default {
  props: {
    dialogshow_historyDetail: false,
    historyItem: {}
  },
  data: () => ({
    BASE_URL: process.env.BASE_URL,

    authen: {},
    headerAPI: {},

  }),
  created () {
    var decode = Decode.decode(localStorage.getItem('key'))
    this.authen = JSON.parse(decode)
    this.headerAPI = {Authorization: this.authen.Authorization}
  },
  watch: {
    dialogshow_historyDetail () {
      // if (this.dialogshow_historyDetail) {
      //   this.changeType()
      //   this.company_name = this.Company.company_name
      //   this.company_detail = this.Company.company_detail
      // }
    }
  },
  methods: {
    // cancel () {
    //   this.company_name = this.Company.company_name
    //   this.company_detail = this.Company.company_detail
    // },
    // changeType () {
    //   if (this.Company.company_type === 'maintenance') {
    //     this.textType_company = 'บริษัทบำรุงรักษาเครื่อง AED'
    //   } else if (this.Company.company_type === 'owner') {
    //     this.textType_company = 'บริษัทในเครือสภากาชาด'
    //   } else if (this.Company.company_type === 'partner') {
    //     this.textType_company = 'บริษัทร่วมโครงการ'
    //   }
    // },
    momentdatethai (data) {
      return Momenttime.momentdatethai(data)
    },
    momenttimethai (data) {
      return Momenttime.momenttimethai(data)
    },
    closeDialog (update) {
      this.$emit('closeshow_historyDetail', false)
    }
    // editCompany () {
    //   var body = {
    //     company_id: this.Company.company_id,
    //     company_detail: this.company_detail,
    //     company_name: this.company_name
    //   }
    //   this.axios.post(process.env.API_BACKEND + '/v1/editCompany', body, {headers: this.headerAPI}).then((response) => {
    //     if (response.data.message === 'success') {
    //       this.$swal( 'สำเร็จ', 'แก้ไขข้อมูล' + this.textType_company + 'สำเร็จแล้ว' , 'success' )
    //       this.closeDialog(true)
    //     } else {
    //       this.$swal( 'ไม่สำเร็จ', 'แก้ไขข้อมูล' + this.textType_company + 'ไม่สำเร็จแล้ว', 'error' )
    //       this.closeDialog(false)
    //     }
    //   })
    // },
    // getComapny () {
    //   this.axios.get(process.env.API_BACKEND + '/v1/getAllCompany', {headers: this.headerAPI}).then((response) => {
    //     if (response.data.message === 'success') {
    //       this.listHeade_company = _.reject(response.data.data, ['company_type', 'maintenance'])
    //     }
    //   })
    // },
    // btncancle () {
    //   this.username = ''
    //   this.password = ''
    //   this.company_name = ''
    //   this.company_address = ''
    //   this.company_email = ''
    //   this.company_tell = ''
    //   this.checkbox1 = false
    //   this.checkbox2 = false
    // }
  }
}
</script>
<style media="screen" scoped>
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
>>>.v-textarea.v-text-field--enclosed.v-text-field--single-line .v-label {
  top: 10px !important;
}
>>>.v-list-item .v-list-item__title {
    font-family: 'Kanit', sans-serif !important;

}
.inputinfor_address {
  height: 110px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor_dis {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: #FAF0F0 !important;
}
>>>.layout.wrap {
  flex-wrap: wrap;
}
>>>.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
.toolbareditdadmin {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: #a80e00 !important;
  color: white !important;
  border-width: thin !important;
  box-shadow: none !important;
}
/* >>>.v-input__slot {
  border-radius: 10px !important;
  border-style: solid !important;
  border-width: thin !important;
  border-color: #a80f00 !important;
  background-color: #a80d0021 !important;
} */
.btngen {
  background-color: white !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
  width: 120px !important;
}
.btnedituser {
  background-color: #a80f00 !important;
  color: #fafafa !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
}
.btnedituser:disabled {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}

.btncancle {
  background-color: #fafafa !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  width: 160px !important;
}
>>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}


>>>.v-input .v-label {
    height: 30px;
    line-height: 30px;
}
.headerRed {
  text-align: left;
    padding: 10px 6px;
    background: #f5e9e8;
    color: #a81000;
    border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/information_print/infor_history_modal.vue